import React from "react";
import { useTranslation } from "react-i18next";

import { HvInput, HvTypography } from "@hitachivantara/uikit-react-core";

import IncidentFilter from "../../incident/IncidentFilter";
import IncidentDatePicker, {
  DatepickerProps,
} from "../../incident/IncidentDatePicker";

import useStyles from "./styles";

interface TableControls {
  onSearch: (value: string) => void;
  onFilter: (value: number[][]) => void;
  totalItemsCount?: number;
  currentItemsCount?: number;
  disabledDatePicker?: boolean;
}

const IncidentsTableControls: React.FC<TableControls & DatepickerProps> = ({
  onSearch,
  onFilter,
  onDateRangeChange,
  startDate,
  endDate,
  totalItemsCount = 0,
  currentItemsCount = 0,
  disabledDatePicker = false,
}) => {
  const { t } = useTranslation("common");
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.leftContainer}>
        <HvInput
          className={classes.inputPlaceholder}
          aria-label={t("common:search.ariaLabel")}
          placeholder={t("common:search.placeholder")}
          type="search"
          onEnter={(event, value) => onSearch?.(value)}
        />
        <HvTypography variant="highlightText">{currentItemsCount}</HvTypography>
        <HvTypography>
          &nbsp;/&nbsp;{totalItemsCount} {t("common:search.items")}
        </HvTypography>
      </div>
      <div className={classes.rightContainer}>
        <IncidentFilter onChange={onFilter} />
        <IncidentDatePicker
          startDate={startDate}
          endDate={endDate}
          onDateRangeChange={onDateRangeChange}
          disabled={disabledDatePicker}
        />
      </div>
    </div>
  );
};

export default IncidentsTableControls;
